import React from 'react';
import cx from 'classnames';
import useBuildVariantProps from '../../../modules/theme/useBuildVariantProps';
import styles from './Table.module.scss';
import type { TableProps } from './Table.types';

const Table = (props: TableProps) => {
  const {
    className,
    children,
    stickyHeader = false,
    ...otherProps
  } = props;

  const tableClassName = cx(
    styles.table,
    {
      [styles.stickyHeader]: stickyHeader,
    },
    className
  );

  const variantProps = useBuildVariantProps(
    'table', {}, {}
  );

  return (
    <table className={tableClassName} {...otherProps} {...variantProps}>
      {children}
    </table>
  );
};

export default Table;
